<template>
    <div>

        <!-- Table -->
        <enac-atpl-dashboard-files-table :id="id" :endpoint="endpoint" :bus="bus" autoload="1" :editing="editing" v-if="loaded">
        </enac-atpl-dashboard-files-table>

        <!-- Creation button -->

        <div class="text-center mt-0" v-show="editing">
            <button class="btn btn-round btn-default" @click="newFile">
                {{ lang.polaris.form.add_file }}
            </button>
        </div>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus" :title="lang.polaris.form.add_file" v-if="editing">
            <enac-atpl-dashboard-files-edit-popup :id="id" :bus="bus" :endpoint="endpoint"></enac-atpl-dashboard-files-edit-popup>
        </trax-ui-modal-default>

        <!-- Local toastr -->

        <trax-ui-toastr :id="id+'-toastr'" passed-label="1" :bus="bus" v-if="editing">
        </trax-ui-toastr>

        <!-- Deletion confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.file_deletion" :bus="bus" v-if="editing">
            {{ lang.polaris.form.confirm_delete_file_q }}
        </trax-ui-modal-confirm>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-files' },
            contextId: {default: 'enac-procedure-atp-daf-edit'},
            disabledWhen: null,
            disabledWhenOr: null
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                registration: data.registration,
                endpoint: app_url+"polaris/api/front/procedures/"+data.procedure.id+"/files",
                contextBus: this.$bus,
                disabled: true,
                loaded: false,
                bus: new Vue()
            }
        },

        computed: {

            editing: function() {
                return this.userPermission && this.statusPermission && !this.disabled;
            },

            userPermission: function() {
                if (this.user.admin) return true; 
                var userFunction = this.user.user_function;
                if (!userFunction) return false; 
                return userFunction == 'training' || userFunction == 'op' || userFunction == 'training_op';
            },

            statusPermission: function() {
                return this.registration.status != 'archived' && !this.disabled;
            }
        },

        created: function() {
            this.contextBus.$on(this.contextId+'-data', this.setData);
            this.contextBus.$on(this.contextId+'-updated', this.setData);
        },

        methods: {
            
            setData: function(procedure) {
                this.disabled = (this.disabledWhen && procedure.data[this.disabledWhen]) || (this.disabledWhenOr && procedure.data[this.disabledWhenOr]);
                if (this.disabled) this.bus.$emit(this.id+'-disable-files');
                this.loaded = true;
            },

            newFile: function() {
                this.bus.$emit(this.id+'-edit-open');
            }

        }

    }
</script>
